<template>
  <div>
    <div v-for="item in menuItems" :key="item.route" v-if="item.allowedUsers.length === 0 || item.allowedUsers.includes(user.id)" class="mb-3">
      <inertia-link class="flex items-center group py-3" :href="route(item.route)">
        <icon :name="item.icon" class="w-4 h-4 mr-2" :class="isUrl(item.route) ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl(item.route) ? 'text-white' : 'text-indigo-300 group-hover:text-white'">{{ item.label }}</div>
      </inertia-link>
    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon';

export default {
  components: {
    Icon,
  },
  computed: {
    user() {
      return this.$page.props.auth.user;
    },
    menuItems() {
      return [
        { route: 'dashboard', label: 'Dashboard', icon: 'dashboard', allowedUsers: [1, 24, 25, 18, 27, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 32, 33, 34, 26, 41] },
        { route: 'customers', label: 'Clienti', icon: 'users', allowedUsers: [1, 24, 25, 3, 27, 5, 6, 7, 8, 17, 9, 10, 11, 12, 13, 14, 15, 18, 21, 31, 32, 33, 34] },
        { route: 'organizations', label: 'Stores', icon: 'office', allowedUsers: [1, 24, 25, 26, 3, 18, 27, 16, 21] },
        { route: 'products', label: 'Prodotti', icon: 'store-front', allowedUsers: [] },
        { route: 'products.searchProduct', label: 'Prezzo Prodotti', icon: 'store-front', allowedUsers: [1, 18, 26, 27] },
        { route: 'batches', label: 'Lotti', icon: 'users', allowedUsers: [1, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 32, 33, 34, 24, 25, 27, 3, 4, 16, 18, 21, 41, 44, 45, 47, 4, 51, 52] },
        { route: 'batchSales', label: 'Vendita Lotti', icon: 'shopping-cart', allowedUsers: [1, 24, 25, 3, 18, 27, 16, 21] },
        { route: 'sales', label: 'Venduti', icon: 'shopping-cart', allowedUsers: [1, 24, 25, 3, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 32, 33, 34, 18, 27] },
        { route: 'discharges', label: 'Scarico', icon: 'office', allowedUsers: [1, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 32, 33, 34, 24, 25, 2, 3, 4, 16, 28, 29, 18, 27, 20, 21, 22, 23, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52] },
        { route: 'loadingProducts', label: 'Carico', icon: 'office', allowedUsers: [1, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 32, 33, 34, 24, 25, 2, 3, 4, 16, 28, 29, 18, 27, 20, 21, 22, 23, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52] },
        { route: 'cart', label: 'Carrello', icon: 'shopping-cart', allowedUsers: [1, 24, 25, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 32, 33, 34, 18, 27] },
      ];
    },
  },
  methods: {
    isUrl(route) {
      return this.$page.url.substr(1).startsWith(route);
    },
  },
};
</script>